import vIcon from "./v-icon.vue";

export default Vue => {
  Vue.component("v-icon", vIcon);
};
